export const Idea = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 25H21" stroke="currentColor" stroke-width="2"/>
<path d="M13 29H19" stroke="currentColor" stroke-width="2"/>
<path d="M20 22C20 21.1525 20.2599 20.3137 21.7011 19.0637C24.2623 16.8423 25 15.141 25 11.6039C25 7.53418 21.1953 3 16 3C10.5622 3 6.98041 7.56537 6.98041 11.9448C6.98041 15.9448 8.70699 17.6869 10.0869 18.847C11.5504 20.0774 12 21.0962 12 22" stroke="currentColor" stroke-width="2"/>
</svg>`;
